import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AnalyticsProvider } from '@johnlewispartnership/wtr-website-analytics';
import { FragmentExperimentsProvider } from '@johnlewispartnership/wtr-website-decisioner-client/express';
import { getAnalytics } from 'analytics';
import { PreloadedDataProvider } from 'contexts/PreloadedData';
import getPreloadedData from 'utils/dataPreloader/getPreloadedData';
import fragmentConfig from 'constants/fragment-config';

import SiteFooter from 'components/Footer/SiteFooter';

const preloadedData = getPreloadedData('footer');

const renderApp = () => {
  const rootElement = createRoot(document.getElementById('common-footer-root')!, {
    identifierPrefix: `${fragmentConfig.footer.identifier}-`,
  });

  rootElement.render(
    <BrowserRouter>
      <AnalyticsProvider
        // eslint-disable-next-line no-underscore-dangle
        initialEvents={window.__WTR_COMMON__?.footer?.analytics}
        analytics={getAnalytics()}
      >
        <FragmentExperimentsProvider
          experimentsContext={preloadedData?.experimentsContext as ExperimentsContextType}
        >
          <PreloadedDataProvider preloadedData={preloadedData}>
            <SiteFooter />
          </PreloadedDataProvider>
        </FragmentExperimentsProvider>
      </AnalyticsProvider>
    </BrowserRouter>,
  );
};

renderApp();
